<template>
  <v-container grid-list-md text-xs-center >
    <v-layout row wrap >
      <v-flex xs4>
      </v-flex>
      <v-flex xs4>
        <v-card dark color="alert">
          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">Single, Double or Triple</h3>
              <div>One Ring, Two Rings or Three Rings</div>
            </div>
          </v-card-title>
          <v-card-actions>
            <v-btn
            flat
            color="orange"
            @click.native.stop="dialog = true">
            >
            Single
            </v-btn>
            <v-btn
            flat
            color="orange"
            @click.native.stop="dialog2 = true">
            >
            Double
            </v-btn>
            <v-btn
            flat
            color="orange"
            @click.native.stop="dialog3 = true">
            >
            Triple
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex xs4>
      </v-flex>
      </v-layout>
      <v-layout row justify-center>
        <v-dialog v-model="dialog" fullscreen transition="dialog-bottom-transition" >
          <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon @click.native.stop="dialog = false" dark>
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Settings</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark flat router to='/'>Save</v-btn>
            </v-toolbar-items>
          </v-toolbar>
            <v-container grid-list-md text-xs-center >
              <v-layout row wrap >
                <v-flex xs4
                v-for="n in 60"
                :key="n"
                >
                <v-btn fab color="red text--black" @click="microMinute(n)"> {{ n }} </v-btn>
                </v-flex>
                <v-flex xs4>
                  <v-row xs4>
                    <v-btn dark fab color="five" @click="soloClock5" > 5 </v-btn>
                    <v-btn dark fab color="ten" @click="soloClock10" > 10 </v-btn>
                    <v-btn dark fab color="fifteen" @click="soloClock15" > 15 </v-btn>
                    <v-btn dark fab color="twenty" @click="soloClock20" > 20 </v-btn>
                    <v-btn dark fab color="twentyfive" @click="soloClock25" > 25 </v-btn>
                    <v-btn dark fab color="thirty" @click="soloClock30" > 30 </v-btn>
                    <v-btn dark fab color="thirtyfive" @click="soloClock35" > 35 </v-btn>
                    <v-btn dark fab color="thirtyfive" @click="soloClock40" > 40 </v-btn>
                    <v-btn dark fab color="thirtyfive" @click="soloClock45" > 45 </v-btn>
                    <v-btn dark fab color="thirtyfive" @click="soloClock50" > 50 </v-btn>
                    <v-btn dark fab color="thirtyfive" @click="soloClock55" > 55 </v-btn>
                    <v-btn dark fab color="thirtyfive" @click="soloClock60" > 60 </v-btn>
                  </v-row>
                </v-flex>
                <v-flex xs4>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-dialog>
      </v-layout>
      <v-layout row justify-center>
        <v-dialog v-model="dialog2" fullscreen transition="dialog-bottom-transition" >
          <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon @click.native.stop="dialog2 = false" dark>
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Settings</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark flat router to='/'>Save</v-btn>
            </v-toolbar-items>
          </v-toolbar>
            <v-container grid-list-md text-xs-center >
              <v-layout row wrap >
                <v-flex xs12>
                  <v-row xs12>
                    <v-btn dark fab class="btn-5-10" small @click="onClock5D10">5-10</v-btn>
                    <v-btn dark fab class="btn-5-15" small @click="onClock5D15">5-15</v-btn>
                    <v-btn dark fab class="btn-5-20" small @click="onClock5D20">5-20</v-btn>
                    <v-btn dark fab class="btn-5-25" small @click="onClock5D25">5-25</v-btn>
                    <v-btn dark fab class="btn-5-30" small @click="onClock5D30">5-30</v-btn>
                    <v-btn dark fab class="btn-5-35" @click="onClock5D35">5-35</v-btn>
                    <v-btn dark fab class="btn-5-35" @click="onClock5D40">5-40</v-btn>
                    <v-btn dark fab class="btn-5-35" @click="onClock5D45">5-45</v-btn>
                    <v-btn dark fab class="btn-5-35" large @click="onClock5D50">5-50</v-btn>
                    <v-btn dark fab class="btn-5-35" large @click="onClock5D55">5-55</v-btn>
                    <v-btn dark fab class="btn-5-35" large @click="onClock5D60">5-60</v-btn>
                  </v-row>
                </v-flex>
                <v-flex xs12>
                  <v-row xs12>
                    <v-btn dark fab class="btn-10-15" small @click="onClock10D15">10-15</v-btn>
                    <v-btn dark fab class="btn-10-20" small @click="onClock10D20">10-20</v-btn>
                    <v-btn dark fab class="btn-10-25" small @click="onClock10D25">10-25</v-btn>
                    <v-btn dark fab class="btn-10-30" small @click="onClock10D30">10-30</v-btn>
                    <v-btn dark fab class="btn-10-35" @click="onClock10D35">10-35</v-btn>
                    <v-btn dark fab class="btn-10-35" @click="onClock10D40">10-40</v-btn>
                    <v-btn dark fab class="btn-10-35" @click="onClock10D45">10-45</v-btn>
                    <v-btn dark fab class="btn-10-35" large @click="onClock10D50">10-50</v-btn>
                    <v-btn dark fab class="btn-10-35" large @click="onClock10D55">10-55</v-btn>
                    <v-btn dark fab class="btn-10-35" large @click="onClock10D60">10-60</v-btn>
                  </v-row>
                </v-flex>
                <v-flex xs12>
                  <v-row xs12>
                    <v-btn dark fab class="btn-15-20" small @click="onClock15D20">15-20</v-btn>
                    <v-btn dark fab class="btn-15-25" small @click="onClock15D25">15-25</v-btn>
                    <v-btn dark fab class="btn-15-30" small @click="onClock15D30">15-30</v-btn>
                    <v-btn dark fab class="btn-15-35" @click="onClock15D35">15-35</v-btn>
                    <v-btn dark fab class="btn-15-35" @click="onClock15D40">15-40</v-btn>
                    <v-btn dark fab class="btn-15-35" @click="onClock15D45">15-45</v-btn>
                    <v-btn dark fab class="btn-15-35" large @click="onClock15D50">15-50</v-btn>
                    <v-btn dark fab class="btn-15-35" large @click="onClock15D55">15-55</v-btn>
                    <v-btn dark fab class="btn-15-35" large @click="onClock15D60">15-60</v-btn>
                  </v-row>
                </v-flex>
                <v-flex xs12>
                  <v-row xs12>
                    <v-btn dark fab class="btn-20-25" small @click="onClock20D25">20-25</v-btn>
                    <v-btn dark fab class="btn-20-30" small @click="onClock20D30">20-30</v-btn>
                    <v-btn dark fab class="btn-20-35" @click="onClock20D35">20-35</v-btn>
                    <v-btn dark fab class="btn-20-35" @click="onClock20D40">20-40</v-btn>
                    <v-btn dark fab class="btn-20-35" @click="onClock20D45">20-45</v-btn>
                    <v-btn dark fab class="btn-20-35" large @click="onClock20D50">20-50</v-btn>
                    <v-btn dark fab class="btn-20-35" large @click="onClock20D55">20-55</v-btn>
                    <v-btn dark fab class="btn-20-35" large @click="onClock20D60">20-60</v-btn>
                  </v-row>
                </v-flex>
                <v-flex xs12>
                  <v-row xs12>
                    <v-btn dark fab class="btn-25-30" small @click="onClock25D30">25-30</v-btn>
                    <v-btn dark fab class="btn-25-35" @click="onClock25D35">25-35</v-btn>
                    <v-btn dark fab class="btn-25-35" @click="onClock25D40">25-40</v-btn>
                    <v-btn dark fab class="btn-25-35" @click="onClock25D45">25-45</v-btn>
                    <v-btn dark fab class="btn-25-35" large @click="onClock25D50">25-50</v-btn>
                    <v-btn dark fab class="btn-25-35" large @click="onClock25D55">25-55</v-btn>
                    <v-btn dark fab class="btn-25-35" large @click="onClock25D60">25-60</v-btn>
                  </v-row>
                </v-flex>
                <v-flex xs12>
                  <v-row xs12>
                    <v-btn dark fab class="btn-30-35" @click="onClock30D35">30-35</v-btn>
                    <v-btn dark fab class="btn-30-35" @click="onClock30D40">30-40</v-btn>
                    <v-btn dark fab class="btn-30-35" @click="onClock30D45">30-45</v-btn>
                    <v-btn dark fab class="btn-30-35" large @click="onClock30D50">30-50</v-btn>
                    <v-btn dark fab class="btn-30-35" large @click="onClock30D55">30-55</v-btn>
                    <v-btn dark fab class="btn-30-35" large @click="onClock30D60">30-60</v-btn>
                  </v-row>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-dialog>
      </v-layout>
      <v-layout row justify-center>
        <v-dialog v-model="dialog3" fullscreen transition="dialog-bottom-transition" >
          <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon @click.native.stop="dialog3 = false" dark>
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Settings</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark flat router to='/'>Save</v-btn>
            </v-toolbar-items>
          </v-toolbar>
            <v-container grid-list-md text-xs-center >
              <v-layout row wrap >
                <v-flex xs12>
                  <v-row xs12>
                    <v-btn dark fab class="btn-5-10-15" @click="onClock5D10D15">5-10-15</v-btn>
                    <v-btn dark fab class="btn-5-10-20" @click="onClock5D10D20">5-10-20</v-btn>
                    <v-btn dark fab class="btn-5-10-25" @click="onClock5D10D25">5-10-25</v-btn>
                    <v-btn dark fab class="btn-5-10-30" @click="onClock5D10D30">5-10-30</v-btn>
                    <v-btn dark fab class="btn-5-10-35" @click="onClock5D10D35">5-10-35</v-btn>
                    <v-btn dark fab class="btn-5-10-35" @click="onClock5D10D40">5-10-40</v-btn>
                    <v-btn dark fab class="btn-5-10-35" @click="onClock5D10D45">5-10-45</v-btn>
                    <v-btn dark fab class="btn-5-10-35" @click="onClock5D10D50">5-10-50</v-btn>
                    <v-btn dark fab class="btn-5-10-35" @click="onClock5D10D55">5-10-55</v-btn>
                    <v-btn dark fab class="btn-5-10-35" @click="onClock5D10D60">5-10-60</v-btn>
                  </v-row>
                </v-flex>
                <v-flex xs12>
                  <v-row xs12>
                    <v-btn dark fab class="btn-5-15-20" @click="onClock5D15D20">5-15-20</v-btn>
                    <v-btn dark fab class="btn-5-15-25" @click="onClock5D15D25">5-15-25</v-btn>
                    <v-btn dark fab class="btn-5-15-30" @click="onClock5D15D30">5-15-30</v-btn>
                    <v-btn dark fab class="btn-5-15-35" @click="onClock5D15D35">5-15-35</v-btn>
                    <v-btn dark fab class="btn-5-15-35" @click="onClock5D15D40">5-15-40</v-btn>
                    <v-btn dark fab class="btn-5-15-35" @click="onClock5D15D45">5-15-45</v-btn>
                    <v-btn dark fab class="btn-5-15-35" @click="onClock5D15D50">5-15-50</v-btn>
                    <v-btn dark fab class="btn-5-15-35" @click="onClock5D15D55">5-15-55</v-btn>
                    <v-btn dark fab class="btn-5-15-35" @click="onClock5D15D60">5-15-60</v-btn>
                  </v-row>
                </v-flex>
                <v-flex xs12>
                  <v-row xs12>
                    <v-btn dark fab class="btn-5-20-25" @click="onClock5D20D25">5-20-25</v-btn>
                    <v-btn dark fab class="btn-5-20-30" @click="onClock5D20D30">5-20-30</v-btn>
                    <v-btn dark fab class="btn-5-20-35" @click="onClock5D20D35">5-20-35</v-btn>
                    <v-btn dark fab class="btn-5-20-35" @click="onClock5D20D40">5-20-40</v-btn>
                    <v-btn dark fab class="btn-5-20-35" @click="onClock5D20D45">5-20-45</v-btn>
                    <v-btn dark fab class="btn-5-20-35" @click="onClock5D20D50">5-20-50</v-btn>
                    <v-btn dark fab class="btn-5-20-35" @click="onClock5D20D55">5-20-55</v-btn>
                    <v-btn dark fab class="btn-5-20-35" @click="onClock5D20D60">5-20-60</v-btn>
                  </v-row>
                </v-flex>
                <v-flex xs12>
                  <v-row xs12>
                    <v-btn dark fab class="btn-5-25-30" @click="onClock5D25D30">5-25-30</v-btn>
                    <v-btn dark fab class="btn-5-25-35" @click="onClock5D25D35">5-25-35</v-btn>
                    <v-btn dark fab class="btn-5-25-35" @click="onClock5D25D40">5-25-40</v-btn>
                    <v-btn dark fab class="btn-5-25-35" @click="onClock5D25D45">5-25-45</v-btn>
                    <v-btn dark fab class="btn-5-25-35" @click="onClock5D25D50">5-25-50</v-btn>
                    <v-btn dark fab class="btn-5-25-35" @click="onClock5D25D55">5-25-55</v-btn>
                    <v-btn dark fab class="btn-5-25-35" @click="onClock5D25D60">5-25-60</v-btn>
                  </v-row>
                </v-flex>
                <v-flex xs12>
                  <v-row xs12>
                    <v-btn dark fab class="btn-5-30-35" @click="onClock5D30D35">5-30-35</v-btn>
                    <v-btn dark fab class="btn-5-30-35" @click="onClock5D30D40">5-30-40</v-btn>
                    <v-btn dark fab class="btn-5-30-35" @click="onClock5D30D45">5-30-45</v-btn>
                    <v-btn dark fab class="btn-5-30-35" @click="onClock5D30D50">5-30-50</v-btn>
                    <v-btn dark fab class="btn-5-30-35" @click="onClock5D30D55">5-30-55</v-btn>
                    <v-btn dark fab class="btn-5-30-35" @click="onClock5D30D60">5-30-60</v-btn>
                  </v-row>
                </v-flex>
                <v-flex xs12>
                  <v-row xs12>
                    <v-btn dark fab class="btn-10-15-20" @click="onClock10D15D20">10-15-20</v-btn>
                    <v-btn dark fab class="btn-10-20-25" @click="onClock10D20D25">10-20-25</v-btn>
                    <v-btn dark fab class="btn-10-20-30" @click="onClock10D20D30">10-20-30</v-btn>
                    <v-btn dark fab class="btn-10-25-30" @click="onClock10D25D30">10-25-30</v-btn>
                    <v-btn dark fab class="btn-10-30-35" @click="onClock10D30D35">10-30-35</v-btn>
                    <v-btn dark fab class="btn-10-30-35" @click="onClock10D30D40">10-30-40</v-btn>
                    <v-btn dark fab class="btn-10-30-35" @click="onClock10D30D45">10-30-45</v-btn>
                    <v-btn dark fab class="btn-10-30-35" @click="onClock10D30D50">10-30-50</v-btn>
                    <v-btn dark fab class="btn-10-30-35" @click="onClock10D30D55">10-30-55</v-btn>
                    <v-btn dark fab class="btn-10-30-35" @click="onClock10D30D60">10-30-60</v-btn>
                  </v-row>
                </v-flex>
                <v-flex xs12>
                  <v-row xs12>
                    <v-btn dark fab class="btn-15-20-25" @click="onClock15D20D25">15-20-25</v-btn>
                    <v-btn dark fab class="btn-15-25-30" @click="onClock15D25D30">15-25-30</v-btn>
                    <v-btn dark fab class="btn-15-30-35" @click="onClock15D30D35">15-30-35</v-btn>
                    <v-btn dark fab class="btn-20-25-30" @click="onClock20D25D30">20-25-30</v-btn>
                    <v-btn dark fab class="btn-20-30-35" @click="onClock20D30D35">20-30-35</v-btn>
                    <v-btn dark fab class="btn-20-30-35" @click="onClock20D30D40">20-30-40</v-btn>
                    <v-btn dark fab class="btn-20-30-35" @click="onClock20D30D45">20-30-45</v-btn>
                    <v-btn dark fab class="btn-20-30-35" @click="onClock20D30D50">20-30-50</v-btn>
                    <v-btn dark fab class="btn-20-30-35" @click="onClock20D30D55">20-30-55</v-btn>
                    <v-btn dark fab class="btn-20-30-35" @click="onClock20D30D60">20-30-60</v-btn>
                  </v-row>
                </v-flex>
                <v-flex xs12>
                  <v-row xs12>
                    <v-btn dark fab class="btn-25-30-35" @click="onClock25D30D35">25-30-35</v-btn>
                    <v-btn dark fab class="btn-25-30-35" @click="onClock25D30D40">25-30-40</v-btn>
                    <v-btn dark fab class="btn-25-30-35" @click="onClock25D30D45">25-30-45</v-btn>
                    <v-btn dark fab class="btn-25-30-35" @click="onClock25D30D50">25-30-50</v-btn>
                    <v-btn dark fab class="btn-25-30-35" @click="onClock25D30D55">25-30-55</v-btn>
                    <v-btn dark fab class="btn-25-30-35" @click="onClock25D30D60">25-30-60</v-btn>
                  </v-row>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-layout>
  </v-container>
</template>
<script>
  export default {
    data () {
      return {
        dialog: false,
        dialog2: false,
        dialog3: false
      }
    },
    computed: {
      minute1 () {
        return this.$store.getters.minutes[0]
      },
      minute2 () {
        return this.$store.getters.minutes[1]
      },
      minute3 () {
        return this.$store.getters.minutes[2]
      },
      travelClocks () {
        return this.$store.getters.travelTimes
      },
      singleClocks () {
        return this.$store.getters.singleTimes
      }
    },
    methods: {
      microMinute (payload) {
        let nock = payload * 60
        let sock = [nock, 0, 0]
        let mock = [payload, '', '', '', '', '', '']
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock5D10 () {
        let sock = [300, 600]
        let mock = [5, 10, '', '', '', '', '']
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        let dock = [5, 10, 0]
        this.$store.dispatch('colorFancyMins', dock)
        this.$router.push('/')
      },
      onClock5D15 () {
        let sock = [300, 900]
        let mock = [5, '', 15, '', '', '', '']
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        let dock = [5, 15, 0]
        this.$store.dispatch('colorFancyMins', dock)
        this.$router.push('/')
      },
      onClock5D20 () {
        let sock = [300, 1200]
        let mock = [5, '', '', 20, '', '', '']
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        let dock = [5, 20, 0]
        this.$store.dispatch('colorFancyMins', dock)
        this.$router.push('/')
      },
      onClock5D25 () {
        let sock = [300, 1500]
        let mock = [5, '', '', '', 25, '', '']
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        let dock = [5, 25, 0]
        this.$store.dispatch('colorFancyMins', dock)
        this.$router.push('/')
      },
      onClock5D30 () {
        let sock = [300, 1800]
        let mock = [5, '', '', '', '', 30, '']
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        let dock = [5, 30, 0]
        this.$store.dispatch('colorFancyMins', dock)
        this.$router.push('/')
      },
      onClock5D35 () {
        let sock = [300, 2100]
        let mock = [5, '', '', '', '', '', 35]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        let dock = [5, 35, 0]
        this.$store.dispatch('colorFancyMins', dock)
        this.$router.push('/')
      },
      onClock5D40 () {
        let sock = [300, 2400]
        let mock = [5, '', '', '', '', '', 40]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        let dock = [5, 40, 0]
        this.$store.dispatch('colorFancyMins', dock)
        this.$router.push('/')
      },
      onClock5D45 () {
        let sock = [300, 2700]
        let mock = [5, '', '', '', '', '', 45]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        let dock = [5, 45, 0]
        this.$store.dispatch('colorFancyMins', dock)
        this.$router.push('/')
      },
      onClock5D50 () {
        let sock = [300, 3000]
        let mock = [5, '', '', '', '', '', 50]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        let dock = [5, 50, 0]
        this.$store.dispatch('colorFancyMins', dock)
        this.$router.push('/')
      },
      onClock5D55 () {
        let sock = [300, 3300]
        let mock = [5, '', '', '', '', '', 55]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        let dock = [5, 55, 0]
        this.$store.dispatch('colorFancyMins', dock)
        this.$router.push('/')
      },
      onClock5D60 () {
        let sock = [300, 3600]
        let mock = [5, '', '', '', '', '', 60]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        let dock = [5, 60, 0]
        this.$store.dispatch('colorFancyMins', dock)
        this.$router.push('/')
      },
      onClock10D15 () {
        let sock = [600, 900]
        let mock = ['', 10, 15, '', '', '', '']
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        let dock = [10, 15, 0]
        this.$store.dispatch('colorFancyMins', dock)
        this.$router.push('/')
      },
      onClock10D20 () {
        let sock = [600, 1200]
        let mock = ['', 10, '', 20, '', '', '']
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        let dock = [10, 20, 0]
        this.$store.dispatch('colorFancyMins', dock)
        this.$router.push('/')
      },
      onClock10D25 () {
        let sock = [600, 1500]
        let mock = ['', 10, '', '', 25, '', '']
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        let dock = [10, 25, 0]
        this.$store.dispatch('colorFancyMins', dock)
        this.$router.push('/')
      },
      onClock10D30 () {
        let sock = [600, 1800]
        let mock = ['', 10, '', '', '', 30, '']
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        let dock = [10, 30, 0]
        this.$store.dispatch('colorFancyMins', dock)
        this.$router.push('/')
      },
      onClock10D35 () {
        let sock = [600, 2100]
        let mock = ['', 10, '', '', '', '', 35]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        let dock = [10, 35, 0]
        this.$store.dispatch('colorFancyMins', dock)
        this.$router.push('/')
      },
      onClock10D40 () {
        let sock = [600, 2400]
        let mock = ['', 10, '', '', '', '', 40]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        let dock = [10, 40, 0]
        this.$store.dispatch('colorFancyMins', dock)
        this.$router.push('/')
      },
      onClock10D45 () {
        let sock = [600, 2700]
        let mock = ['', 10, '', '', '', '', 45]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        let dock = [10, 45, 0]
        this.$store.dispatch('colorFancyMins', dock)
        this.$router.push('/')
      },
      onClock10D50 () {
        let sock = [600, 3000]
        let mock = ['', 10, '', '', '', '', 50]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        let dock = [10, 50, 0]
        this.$store.dispatch('colorFancyMins', dock)
        this.$router.push('/')
      },
      onClock10D55 () {
        let sock = [600, 3300]
        let mock = ['', 10, '', '', '', '', 55]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        let dock = [10, 55, 0]
        this.$store.dispatch('colorFancyMins', dock)
        this.$router.push('/')
      },
      onClock10D60 () {
        let sock = [600, 3600]
        let mock = ['', 10, '', '', '', '', 60]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        let dock = [10, 60, 0]
        this.$store.dispatch('colorFancyMins', dock)
        this.$router.push('/')
      },
      onClock15D20 () {
        let sock = [900, 1200]
        let mock = ['', '', 15, 20, '', '', '']
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock15D25 () {
        let sock = [900, 1500]
        let mock = ['', '', 15, '', 25, '', '']
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock15D30 () {
        let sock = [900, 1800]
        let mock = ['', '', 15, '', '', 30, '']
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock15D35 () {
        let sock = [900, 2100]
        let mock = ['', '', 15, '', '', '', 35]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock15D40 () {
        let sock = [900, 2400]
        let mock = ['', '', 15, '', '', '', 40]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock15D45 () {
        let sock = [900, 2700]
        let mock = ['', '', 15, '', '', '', 45]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock15D50 () {
        let sock = [900, 3000]
        let mock = ['', '', 15, '', '', '', 50]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock15D55 () {
        let sock = [900, 3300]
        let mock = ['', '', 15, '', '', '', 55]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock15D60 () {
        let sock = [900, 3600]
        let mock = ['', '', 15, '', '', '', 60]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock20D25 () {
        let sock = [1200, 1500]
        let mock = ['', '', '', 20, 25, '', '']
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock20D30 () {
        let sock = [1200, 1800]
        let mock = ['', '', '', 20, '', 30, '']
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock20D35 () {
        let sock = [1200, 2100]
        let mock = ['', '', '', 20, '', '', 35]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock20D40 () {
        let sock = [1200, 2400]
        let mock = ['', '', '', 20, '', '', 40]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock20D45 () {
        let sock = [1200, 2700]
        let mock = ['', '', '', 20, '', '', 45]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock20D50 () {
        let sock = [1200, 3000]
        let mock = ['', '', '', 20, '', '', 50]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock20D55 () {
        let sock = [1200, 3300]
        let mock = ['', '', '', 20, '', '', 55]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock20D60 () {
        let sock = [1200, 3600]
        let mock = ['', '', '', 20, '', '', 60]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock25D30 () {
        let sock = [1500, 1800]
        let mock = ['', '', '', '', 25, 30, '']
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock25D35 () {
        let sock = [1500, 2100]
        let mock = ['', '', '', '', 25, '', 35]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock25D40 () {
        let sock = [1500, 2400]
        let mock = ['', '', '', '', 25, '', 40]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock25D45 () {
        let sock = [1500, 2700]
        let mock = ['', '', '', '', 25, '', 45]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock25D50 () {
        let sock = [1500, 3000]
        let mock = ['', '', '', '', 25, '', 50]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock25D55 () {
        let sock = [1500, 3300]
        let mock = ['', '', '', '', 25, '', 55]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock25D60 () {
        let sock = [1500, 3600]
        let mock = ['', '', '', '', 25, '', 60]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock30D35 () {
        let sock = [1800, 2100]
        let mock = ['', '', '', '', '', 30, 35]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock30D40 () {
        let sock = [1800, 2400]
        let mock = ['', '', '', '', '', 30, 40]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock30D45 () {
        let sock = [1800, 2700]
        let mock = ['', '', '', '', '', 30, 45]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock30D50 () {
        let sock = [1800, 3000]
        let mock = ['', '', '', '', '', 30, 50]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock30D55 () {
        let sock = [1800, 3300]
        let mock = ['', '', '', '', '', 30, 55]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock30D60 () {
        let sock = [1800, 3600]
        let mock = ['', '', '', '', '', 30, 60]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock5D10D15 () {
        let sock = [300, 600, 900]
        let mock = [5, 10, 15, '', '', '', '']
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock5D10D20 () {
        let sock = [300, 600, 1200]
        let mock = [5, 10, '', 20, '', '', '']
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock5D10D25 () {
        let sock = [300, 600, 1500]
        let mock = [5, 10, '', '', 25, '', '']
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock5D10D30 () {
        let sock = [300, 600, 1800]
        let mock = [5, 10, '', '', '', 30, '']
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock5D10D35 () {
        let sock = [300, 600, 2100]
        let mock = [5, 10, '', '', '', '', 35]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock5D10D40 () {
        let sock = [300, 600, 2400]
        let mock = [5, 10, '', '', '', '', 40]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock5D10D45 () {
        let sock = [300, 600, 2700]
        let mock = [5, 10, '', '', '', '', 45]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock5D10D50 () {
        let sock = [300, 600, 3000]
        let mock = [5, 10, '', '', '', '', 50]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock5D10D55 () {
        let sock = [300, 600, 3300]
        let mock = [5, 10, '', '', '', '', 55]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock5D10D60 () {
        let sock = [300, 600, 3600]
        let mock = [5, 10, '', '', '', '', 60]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock5D15D20 () {
        let sock = [300, 900, 1200]
        let mock = [5, '', 15, 20, '', '', '']
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock5D15D25 () {
        let sock = [300, 900, 1500]
        let mock = [5, '', 15, '', 25, '', '']
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock5D15D30 () {
        let sock = [300, 900, 1800]
        let mock = [5, '', 15, '', '', 30, '']
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock5D15D35 () {
        let sock = [300, 900, 2100]
        let mock = [5, '', 15, '', '', '', 35]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock5D15D40 () {
        let sock = [300, 900, 2400]
        let mock = [5, '', 15, '', '', '', 40]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock5D15D45 () {
        let sock = [300, 900, 2700]
        let mock = [5, '', 15, '', '', '', 45]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock5D15D50 () {
        let sock = [300, 900, 3000]
        let mock = [5, '', 15, '', '', '', 50]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock5D15D55 () {
        let sock = [300, 900, 3300]
        let mock = [5, '', 15, '', '', '', 55]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock5D15D60 () {
        let sock = [300, 900, 3600]
        let mock = [5, '', 15, '', '', '', 60]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock5D20D25 () {
        let sock = [300, 1200, 1500]
        let mock = [5, '', '', 20, 25, '', '']
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock5D20D30 () {
        let sock = [300, 1200, 1800]
        let mock = [5, '', '', 20, '', 30, '']
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock5D20D35 () {
        let sock = [300, 1200, 2100]
        let mock = [5, '', '', 20, '', '', 35]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock5D20D40 () {
        let sock = [300, 1200, 2400]
        let mock = [5, '', '', 20, '', '', 40]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock5D20D45 () {
        let sock = [300, 1200, 2700]
        let mock = [5, '', '', 20, '', '', 45]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock5D20D50 () {
        let sock = [300, 1200, 3000]
        let mock = [5, '', '', 20, '', '', 50]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock5D20D55 () {
        let sock = [300, 1200, 3300]
        let mock = [5, '', '', 20, '', '', 55]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock5D20D60 () {
        let sock = [300, 1200, 3600]
        let mock = [5, '', '', 20, '', '', 60]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock5D25D30 () {
        let sock = [300, 1500, 1800]
        let mock = [5, '', '', '', 25, 30, '']
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock5D25D35 () {
        let sock = [300, 1500, 2100]
        let mock = [5, '', '', '', 25, '', 35]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock5D25D40 () {
        let sock = [300, 1500, 2400]
        let mock = [5, '', '', '', 25, '', 40]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock5D25D45 () {
        let sock = [300, 1500, 2700]
        let mock = [5, '', '', '', 25, '', 45]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock5D25D50 () {
        let sock = [300, 1500, 3000]
        let mock = [5, '', '', '', 25, '', 50]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock5D25D55 () {
        let sock = [300, 1500, 3300]
        let mock = [5, '', '', '', 25, '', 55]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock5D25D60 () {
        let sock = [300, 1500, 3600]
        let mock = [5, '', '', '', 25, '', 60]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock5D30D35 () {
        let sock = [300, 1800, 2100]
        let mock = [5, '', '', '', '', 30, 35]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock5D30D40 () {
        let sock = [300, 1800, 2400]
        let mock = [5, '', '', '', '', 30, 40]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock5D30D45 () {
        let sock = [300, 1800, 2700]
        let mock = [5, '', '', '', '', 30, 45]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock5D30D50 () {
        let sock = [300, 1800, 3000]
        let mock = [5, '', '', '', '', 30, 50]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock5D30D55 () {
        let sock = [300, 1800, 3300]
        let mock = [5, '', '', '', '', 30, 55]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock5D30D60 () {
        let sock = [300, 1800, 3600]
        let mock = [5, '', '', '', '', 30, 60]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock20D25D30 () {
        let sock = [1200, 1500, 1800]
        let mock = ['', '', '', 20, 25, 30, '']
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock15D25D30 () {
        let sock = [900, 1500, 1800]
        let mock = ['', '', 15, '', 25, 30, '']
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock15D30D35 () {
        let sock = [900, 1800, 2100]
        let mock = ['', '', 15, '', '', 30, 35]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock15D20D25 () {
        let sock = [900, 1200, 1500]
        let mock = ['', '', 15, 20, 25, '', '']
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock20D30D35 () {
        let sock = [1200, 1800, 2100]
        let mock = ['', '', '', 20, '', 30, 35]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock20D30D40 () {
        let sock = [1200, 1800, 2400]
        let mock = ['', '', '', 20, '', 30, 40]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock20D30D45 () {
        let sock = [1200, 1800, 2700]
        let mock = ['', '', '', 20, '', 30, 45]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock20D30D50 () {
        let sock = [1200, 1800, 3000]
        let mock = ['', '', '', 20, '', 30, 50]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock20D30D55 () {
        let sock = [1200, 1800, 3300]
        let mock = ['', '', '', 20, '', 30, 55]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock20D30D60 () {
        let sock = [1200, 1800, 3600]
        let mock = ['', '', '', 20, '', 30, 60]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock25D30D35 () {
        let sock = [1500, 1800, 2100]
        let mock = ['', '', '', '', 25, 30, 35]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock25D30D40 () {
        let sock = [1500, 1800, 2400]
        let mock = ['', '', '', '', 25, 30, 40]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock25D30D45 () {
        let sock = [1500, 1800, 2700]
        let mock = ['', '', '', '', 25, 30, 45]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock25D30D50 () {
        let sock = [1500, 1800, 3000]
        let mock = ['', '', '', '', 25, 30, 50]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock25D30D55 () {
        let sock = [1500, 1800, 3300]
        let mock = ['', '', '', '', 25, 30, 55]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock25D30D60 () {
        let sock = [1500, 1800, 3600]
        let mock = ['', '', '', '', 25, 30, 60]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock10D30D35 () {
        let sock = [600, 1800, 2100]
        let mock = ['', 10, '', '', '', 30, 35]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock10D30D40 () {
        let sock = [600, 1800, 2400]
        let mock = ['', 10, '', '', '', 30, 40]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock10D30D45 () {
        let sock = [600, 1800, 2700]
        let mock = ['', 10, '', '', '', 30, 45]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock10D30D50 () {
        let sock = [600, 1800, 3000]
        let mock = ['', 10, '', '', '', 30, 50]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock10D30D55 () {
        let sock = [600, 1800, 3300]
        let mock = ['', 10, '', '', '', 30, 55]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock10D30D60 () {
        let sock = [600, 1800, 3600]
        let mock = ['', 10, '', '', '', 30, 60]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock10D15D20 () {
        let sock = [600, 900, 1200]
        let mock = ['', 10, 15, 20, '', '', '']
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock10D20D25 () {
        let sock = [600, 1200, 1500]
        let mock = ['', 10, '', 20, 25, '', '']
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock10D20D30 () {
        let sock = [600, 1200, 1800]
        let mock = ['', 10, '', 20, '', 30, '']
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      onClock10D25D30 () {
        let sock = [600, 1500, 1800]
        let mock = ['', 10, '', '', 25, 30, '']
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      },
      soloClock5 () {
        let sock = [300]
        let mock = [5]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        let dock = [5, 0, 0]
        this.$store.dispatch('colorFancyMins', dock)
        this.$router.push('/')
      },
      soloClock10 () {
        let sock = [600]
        let mock = ['', 10]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        let dock = [10, 0, 0]
        this.$store.dispatch('colorFancyMins', dock)
        this.$router.push('/')
      },
      soloClock15 () {
        let sock = [900]
        let mock = ['', '', 15]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        let dock = [15, 0, 0]
        this.$store.dispatch('colorFancyMins', dock)
        this.$router.push('/')
      },
      soloClock20 () {
        let sock = [1200]
        let mock = ['', '', '', 20]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        let dock = [20, 0, 0]
        this.$store.dispatch('colorFancyMins', dock)
        this.$router.push('/')
      },
      soloClock25 () {
        let sock = [1500]
        let mock = ['', '', '', '', 25]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        let dock = [25, 0, 0]
        this.$store.dispatch('colorFancyMins', dock)
        this.$router.push('/')
      },
      soloClock30 () {
        let sock = [1800]
        let mock = ['', '', '', '', '', 30]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        let dock = [30, 0, 0]
        this.$store.dispatch('colorFancyMins', dock)
        this.$router.push('/')
      },
      soloClock35 () {
        let sock = [2100]
        let mock = ['', '', '', '', '', '', 35]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        let dock = [35, 0, 0]
        this.$store.dispatch('colorFancyMins', dock)
        this.$router.push('/')
      },
      soloClock40 () {
        let sock = [2400]
        let mock = ['', '', '', '', '', '', 40]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        let dock = [40, 0, 0]
        this.$store.dispatch('colorFancyMins', dock)
        this.$router.push('/')
      },
      soloClock45 () {
        let sock = [2700]
        let mock = ['', '', '', '', '', '', 45]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        let dock = [45, 0, 0]
        this.$store.dispatch('colorFancyMins', dock)
        this.$router.push('/')
      },
      soloClock50 () {
        let sock = [3000]
        let mock = ['', '', '', '', '', '', 50]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        let dock = [50, 0, 0]
        this.$store.dispatch('colorFancyMins', dock)
        this.$router.push('/')
      },
      soloClock55 () {
        let sock = [3300]
        let mock = ['', '', '', '', '', '', 55]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        let dock = [55, 0, 0]
        this.$store.dispatch('colorFancyMins', dock)
        this.$router.push('/')
      },
      soloClock60 () {
        let sock = [3600]
        let mock = ['', '', '', '', '', '', 60]
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        let dock = [60, 0, 0]
        this.$store.dispatch('colorFancyMins', dock)
        this.$router.push('/')
      },
      onClock51015 () {
        let sock = [300, 600, 900]
        let mock = [5, 10, 15, '', '', '', '', '', '', '', '', '']
        this.$store.dispatch('pickSecs', sock)
        this.$store.dispatch('pickMins', mock)
        this.$router.push('/')
      }
    }
  }
</script>

<style>
.btn-1 {
  background-image: linear-gradient(to right, #f6d365 0%, #fda085 51%, #f6d365 100%);
}
.btn-5-10 {
  background-image: linear-gradient(to right, #7fa995 0%, #96c79d 100%);
}
.btn-5-15 {
  background-image: linear-gradient(to right, #7fa995 0%, #b7ce98 100%);
}
.btn-5-20 {
  background-image: linear-gradient(to right, #7fa995 0%, #e2ba8b 100%);
}
.btn-5-25 {
  background-image: linear-gradient(to right, #7fa995 0%, #dfa38d 100%);
}
.btn-5-30 {
  background-image: linear-gradient(to right, #7fa995 0%, #cc8f91 100%);
}
.btn-5-35 {
  background-image: linear-gradient(to right, #7fa995 0%, #7f7f7f 100%);
}
.btn-5-10 {
  background-image: linear-gradient(to right, #7fa995 0%, #96c79d 100%);
}
.btn-10-15 {
  background-image: linear-gradient(to right, #96c79d 0%, #b7ce98 100%);
}
.btn-10-20 {
  background-image: linear-gradient(to right, #96c79d 0%, #e2ba8b 100%);
}
.btn-10-25 {
  background-image: linear-gradient(to right, #96c79d 0%, #dfa38d 100%);
}
.btn-10-30 {
  background-image: linear-gradient(to right, #96c79d 0%, #cc8f91 100%);
}
.btn-10-35 {
  background-image: linear-gradient(to right, #96c79d 0%, #7f7f7f 100%);
}
.btn-15-20 {
  background-image: linear-gradient(to right, #b7ce98 0%, #e2ba8b 100%);
}
.btn-15-25 {
  background-image: linear-gradient(to right, #b7ce98 0%, #dfa38d 100%);
}
.btn-15-30 {
  background-image: linear-gradient(to right, #b7ce98 0%, #cc8f91 100%);
}
.btn-15-35 {
  background-image: linear-gradient(to right, #b7ce98 0%, #7f7f7f 100%);
}
.btn-20-25 {
  background-image: linear-gradient(to right, #e2ba8b 0%, #dfa38d 100%);
}
.btn-20-30 {
  background-image: linear-gradient(to right, #e2ba8b 0%, #cc8f91 100%);
}
.btn-20-35 {
  background-image: linear-gradient(to right, #e2ba8b 0%, #7f7f7f 100%);
}
.btn-25-30 {
  background-image: linear-gradient(to right, #dfa38d 0%, #cc8f91 100%);
}
.btn-25-35 {
  background-image: linear-gradient(to right, #dfa38d 0%, #7f7f7f 100%);
}
.btn-30-35 {
  background-image: linear-gradient(to right, #cc8f91 0%, #7f7f7f 100%);
}
.btn-5-10-15 {
  background-image: linear-gradient(to right, #7fa995 0%, #96c79d 51%, #b7ce98 100%);
}
.btn-5-15-20 {
  background-image: linear-gradient(to right, #7fa995 0%, #b7ce98 51%, #e2ba8b 100%);
}
.btn-5-20-25 {
  background-image: linear-gradient(to right, #7fa995 0%, #e2ba8b 51%, #dfa38d 100%);
}
.btn-5-25-30 {
  background-image: linear-gradient(to right, #7fa995 0%, #dfa38d 51%, #cc8f91 100%);
}
.btn-5-30-35 {
  background-image: linear-gradient(to right, #7fa995 0%, #cc8f91 51%, #7f7f7f 100%);
}
.btn-10-15-20 {
  background-image: linear-gradient(to right, #96c79d 0%, #b7ce98 51%, #e2ba8b 100%);
}
.btn-10-20-25 {
  background-image: linear-gradient(to right, #96c79d 0%, #e2ba8b 51%, #dfa38d 100%);
}
.btn-10-20-30 {
  background-image: linear-gradient(to right, #96c79d 0%, #e2ba8b 51%, #cc8f91 100%);
}
.btn-10-25-30 {
  background-image: linear-gradient(to right, #7fa995 0%, #dfa38d 51%, #cc8f91 100%);
}
.btn-10-30-35 {
  background-image: linear-gradient(to right, #96c79d 0%, #cc8f91 51%, #7f7f7f 100%);
}
.btn-15-20-25 {
  background-image: linear-gradient(to right, #b7ce98 0%, #e2ba8b 51%, #dfa38d 100%);
}
.btn-15-25-30 {
  background-image: linear-gradient(to right, #b7ce98 0%, #cc8f91 51%, #cc8f91 100%);
}
.btn-15-30-35 {
  background-image: linear-gradient(to right, #b7ce98 0%, #cc8f91 51%, #7f7f7f 100%);
}
.btn-20-25-30 {
  background-image: linear-gradient(to right, #e2ba8b 0%, #dfa38d 51%, #cc8f91 100%);
}
.btn-20-30-35 {
  background-image: linear-gradient(to right, #e2ba8b 0%, #cc8f91 51%, #7f7f7f 100%);
}
.btn-25-30-35 {
  background-image: linear-gradient(to right, #dfa38d 0%, #cc8f91 51%, #7f7f7f 100%);
}
.btn-5-10-15 {
  background-image: linear-gradient(to right, #7fa995 0%, #96c79d 51%, #b7ce98 100%);
}
.btn-5-10-20 {
  background-image: linear-gradient(to right, #7fa995 0%, #96c79d 51%, #e2ba8b 100%);
}
.btn-5-10-25 {
  background-image: linear-gradient(to right, #7fa995 0%, #96c79d 51%, #dfa38d 100%);
}
.btn-5-10-30 {
  background-image: linear-gradient(to right, #7fa995 0%, #96c79d 51%, #cc8f91 100%);
}
.btn-5-10-35 {
  background-image: linear-gradient(to right, #7fa995 0%, #96c79d 51%, #7f7f7f 100%);
}
.btn-5-15-20 {
  background-image: linear-gradient(to right, #7fa995 0%, #b7ce98 51%, #e2ba8b 100%);
}
.btn-5-15-25 {
  background-image: linear-gradient(to right, #7fa995 0%, #b7ce98 51%, #dfa38d 100%);
}
.btn-5-15-30 {
  background-image: linear-gradient(to right, #7fa995 0%, #b7ce98 51%, #cc8f91 100%);
}
.btn-5-15-35 {
  background-image: linear-gradient(to right, #7fa995 0%, #b7ce98 51%, #7f7f7f 100%);
}
.btn-5-20-25 {
  background-image: linear-gradient(to right, #7fa995 0%, #e2ba8b 51%, #dfa38d 100%);
}
.btn-5-20-30 {
  background-image: linear-gradient(to right, #7fa995 0%, #e2ba8b 51%, #cc8f91 100%);
}
.btn-5-20-35 {
  background-image: linear-gradient(to right, #7fa995 0%, #e2ba8b 51%, #7f7f7f 100%);
}
.btn-5-25-30 {
  background-image: linear-gradient(to right, #7fa995 0%, #dfa38d 51%, #cc8f91 100%);
}
.btn-5-25-35 {
  background-image: linear-gradient(to right, #7fa995 0%, #dfa38d 51%, #7f7f7f 100%);
}
.btn-5-30-35 {
  background-image: linear-gradient(to right, #7fa995 0%, #cc8f91 51%, #7f7f7f 100%);
}
.btn-10-15-20 {
  background-image: linear-gradient(to right, #96c79d 0%, #b7ce98 51%, #e2ba8b 100%);
}
.btn-10-20-25 {
  background-image: linear-gradient(to right, #96c79d 0%, #e2ba8b 51%, #dfa38d 100%);
}
.btn-10-25-30 {
  background-image: linear-gradient(to right, #96c79d 0%, #dfa38d 51%, #cc8f91 100%);
}
.btn-10-30-35 {
  background-image: linear-gradient(to right, #96c79d 0%, #cc8f91 51%, #7f7f7f 100%);
}
.btn-15-20-25 {
  background-image: linear-gradient(to right, #b7ce98 0%, #e2ba8b 51%, #dfa38d 100%);
}
.btn-15-25-30 {
  background-image: linear-gradient(to right, #b7ce98 0%, #dfa38d 51%, #cc8f91 100%);
}
.btn-15-30-35 {
  background-image: linear-gradient(to right, #b7ce98 0%, #cc8f91 51%, #7f7f7f 100%);
}
.btn-20-25-30 {
  background-image: linear-gradient(to right, #e2ba8b 0%, #dfa38d 51%, #cc8f91 100%);
}
.btn-20-30-35 {
  background-image: linear-gradient(to right, #e2ba8b 0%, #cc8f91 51%, #7f7f7f 100%);
}
</style>



// WEBPACK FOOTER //
// src/components/toolBox/timePicker.vue